import {TweenMax, TimelineMax, Linear} from 'gsap';
export default class PreviewEffects{

    constructor(props){
       this.tween = new TimelineMax({paused : true});
       this.killTween   = this.killTween.bind(this);
       this.browserName = props.browserName;
       this.width = props.width;
       this.height = props.height;
       this.zoomFactor = props.zoomFactor;
    }

    maskExist(elementId, type)
    {
        if (!type)
        type = "";

        if (document.getElementById("mymask_" + elementId + type))
            return true;
        else
            return false;
    }

    removeMask(elementId)
    {
        var mask_name = "mymask_" + elementId;
        var elements = [];
        var tmpsvg, par;
        elements = document.querySelectorAll('*[id^="' + mask_name + '"]');

        for (var cnt = 0; cnt < elements.length; cnt++)
        {
        tmpsvg = document.getElementById(elements[cnt].id);
        if (tmpsvg !== null)
        {
            par = tmpsvg.parentNode;
            par.removeChild(tmpsvg);
            par.parentNode.removeChild(par)
            document.getElementById(elementId).removeAttribute("mask");
        }
        }
    }

    addMask(elementId, type, direction, rotation, scaleX, scaleY, effectType, isScene) 
    {
        var val = document.getElementById(elementId);
        var bounds = val.getBoundingClientRect();
        if (!scaleX) scaleX = 1; if (!scaleY) scaleY = 1;
        if (!direction)
        direction = "";
        if (!type)
        type = "";
        if (val !== null) {
        var mask_rect = "mask_" + elementId + "_rect";
        var mask_tag = document.createElementNS('http://www.w3.org/2000/svg', "clipPath");
        var mask_name, myRect;
        var mySVG = document.createElementNS('http://www.w3.org/2000/svg', "svg");
        var totalCount = 10, count;

        if (type === "multiWidth" || type === "multiHeight") {
            mask_name = "mymask_" + elementId + type;
            let h = val.offsetHeight;
            let w = val.offsetWidth;
            val.style.clipPath = "url(#" + mask_name + ")";
            val.style.webkitClipPath = "url(#" + mask_name + ")"; val.style.mozClipPath = "url(#" + mask_name + ")"; val.style.msClipPath = "url(#" + mask_name + ")"; val.style.oClipPath = "url(#" + mask_name + ")";
            mask_tag.setAttributeNS(null, "id", mask_name);
            for (count = 0; count < totalCount; count++) {
            if (type === "multiWidth")
            myRect = this.addMaskDOM("rect", (mask_rect + count), ((count * (w / totalCount))), 0, ((w / totalCount) + 1), h, val.getAttribute("stroke-width"))
            else if (type === "multiHeight")
                myRect = this.addMaskDOM("rect", (mask_rect + count), 0, ((count * h / totalCount)), w, ((h / totalCount) + 1), val.getAttribute("stroke-width"))
            mask_tag.appendChild(myRect);
            }

            mySVG.setAttributeNS(null, "width", 0);
            mySVG.setAttributeNS(null, "height", 0);

            mySVG.appendChild(mask_tag);
            document.getElementById(elementId).appendChild(mySVG);
        }
        else if (type === "square" || type === "slidesquare" || type === "pixelsquare") {

            if (effectType !== "exit") {
            mask_name = "mymask_" + elementId + type;
            }
            else {
            mask_name = "mymask_" + elementId + "exitsquare";
            mask_rect += "exit"
            }

            val.style.clipPath = "url(#" + mask_name + ")";
            val.style.webkitClipPath = "url(#" + mask_name + ")"; val.style.mozClipPath = "url(#" + mask_name + ")"; val.style.msClipPath = "url(#" + mask_name + ")"; val.style.oClipPath = "url(#" + mask_name + ")";
            mask_tag.setAttributeNS(null, "id", mask_name);
            let h = document.getElementById(elementId).offsetHeight;
            let w = document.getElementById(elementId).offsetWidth;
            var totalSquare = 6;
            if (type === "square") totalSquare = 6;
            for (count = 0; count < totalSquare; count++) {
            for (var cnt = 0; cnt < totalSquare; cnt++) {

                var changeValY = cnt * h / totalSquare;
                var changeValX = count * w / totalSquare;
                myRect = this.addMaskDOM("rect", (mask_rect + count + cnt), changeValX, changeValY, ((w / totalSquare) + 1), ((h / totalSquare) + 1), val.getAttribute("stroke-width"));
                mask_tag.appendChild(myRect);
            }
            }

            mySVG.setAttributeNS(null, "width", 0);
            mySVG.setAttributeNS(null, "height", 0);

            mySVG.appendChild(mask_tag);
            document.getElementById(elementId).appendChild(mySVG);
        }
        else if (type === "splitVer" || type === "splitHor") {
            totalCount = 2;

            mask_name = "mymask_" + elementId + "split";
            val.style.clipPath = "url(#" + mask_name + ")";
            val.style.webkitClipPath = "url(#" + mask_name + ")"; val.style.mozClipPath = "url(#" + mask_name + ")"; val.style.msClipPath = "url(#" + mask_name + ")"; val.style.oClipPath = "url(#" + mask_name + ")";
            mask_tag.setAttributeNS(null, "id", mask_name);
            let h = bounds.height;
            let w = bounds.width;
            for (count = 0; count < totalCount; count++) {
            if (type === "splitHor")
                myRect = this.addMaskDOM("rect", (mask_rect + count), 0, ((count * h / 2)), w, ((h / totalCount) + 1), val.getAttribute("stroke-width"))
            else
                myRect = this.addMaskDOM("rect", (mask_rect + count), ((count * w / 2)), 0, ((w / totalCount) + 1), h, val.getAttribute("stroke-width"))
            
            mask_tag.appendChild(myRect);
            }
            mySVG.setAttributeNS(null, "width", 0);
            mySVG.setAttributeNS(null, "height", 0);
            mySVG.appendChild(mask_tag);
            document.getElementById(elementId).appendChild(mySVG);
        }
        else if (type === "circle") {
            mask_name = "mymask_" + elementId + type;
            val.style.clipPath = "url(#" + mask_name + ")";
            val.style.webkitClipPath = "url(#" + mask_name + ")"; val.style.mozClipPath = "url(#" + mask_name + ")"; val.style.msClipPath = "url(#" + mask_name + ")"; val.style.oClipPath = "url(#" + mask_name + ")";

            mask_tag.setAttributeNS(null, "id", mask_name);

            var myCir = document.createElementNS('http://www.w3.org/2000/svg', "circle");
            myCir.setAttributeNS(null, "id", mask_rect);
            myCir.setAttributeNS(null, "cx", (document.getElementById(elementId).offsetWidth) / 2);
            myCir.setAttributeNS(null, "cy", (document.getElementById(elementId).offsetHeight) / 2);
            myCir.setAttributeNS(null, "r", (document.getElementById(elementId).offsetWidth + document.getElementById(elementId).offsetHeight) / 2);
            myCir.setAttributeNS(null, "stroke-width", val.getAttribute("stroke-width"));
            myCir.setAttributeNS(null, "fill", "beige");
            myCir.setAttributeNS(null, "stroke", "beige");

            mask_tag.appendChild(myCir);

            mySVG.setAttributeNS(null, "width", 0);
            mySVG.setAttributeNS(null, "height", 0);

            mySVG.appendChild(mask_tag);
            document.getElementById(elementId).appendChild(mySVG);

        }
        else if (type === "circularReveal") {
            mask_name = "mymask_" + elementId + type;
            val.style.clipPath = "url(#" + mask_name + ")";
            val.style.webkitClipPath = "url(#" + mask_name + ")"; val.style.mozClipPath = "url(#" + mask_name + ")"; val.style.msClipPath = "url(#" + mask_name + ")"; val.style.oClipPath = "url(#" + mask_name + ")";

            mask_tag.setAttributeNS(null, "id", mask_name);

            var myPath = document.createElementNS('http://www.w3.org/2000/svg', "path");
            myPath.setAttributeNS(null, "id", "arcPath" + elementId);
            myPath.setAttributeNS(null, "d", " ");

            mask_tag.appendChild(myPath);

            mySVG.setAttributeNS(null, "width", 0);
            mySVG.setAttributeNS(null, "height", 0);

            mySVG.appendChild(mask_tag);

            // document.getElementById(elementId).parentElement.appendChild(mySVG);
            document.getElementById(elementId).appendChild(mySVG);
        }
        else {

            mask_name = "mymask_" + elementId + type;
            val.style.clipPath = "url(#" + mask_name + ")";
            val.style.webkitClipPath = "url(#" + mask_name + ")"; val.style.mozClipPath = "url(#" + mask_name + ")"; val.style.msClipPath = "url(#" + mask_name + ")"; val.style.oClipPath = "url(#" + mask_name + ")";

            mask_tag.setAttributeNS(null, "id", mask_name);

            var h = bounds.height > document.getElementById(elementId).offsetHeight ? bounds.height : document.getElementById(elementId).offsetHeight; //* Math.abs(Math.cos(rotation)) + bounds.width * Math.abs(Math.sin(rotation));
            var w = bounds.width > document.getElementById(elementId).offsetWidth ? bounds.width : document.getElementById(elementId).offsetWidth; //* Math.abs(Math.cos(rotation)) + bounds.height * Math.abs(Math.sin(rotation));
            if (type === "reveal" || type === "irish") {
            h = document.getElementById(elementId).offsetHeight;
            w = document.getElementById(elementId).offsetWidth;
            }

            myRect = this.addMaskDOM("rect", mask_rect, 0, 0, w, h);
            mask_tag.appendChild(myRect);

            mySVG.setAttributeNS(null, "width", 0);
            mySVG.setAttributeNS(null, "height", 0);

            if (rotation) {
            if (scaleX === scaleY)
                rotation *= -1;
            var rotVal = "rotate(" + rotation + ")"
            myRect.setAttribute("transform", rotVal);
            }

            mySVG.appendChild(mask_tag);
            // document.getElementById(elementId).parentElement.appendChild(mySVG);
            // if(isScene)
            document.getElementById(elementId).appendChild(mySVG);
            // else
            //   document.getElementById(elementId).insertBefore(mySVG, document.getElementById(elementId).childNodes[0]);
            if (type !== "wipe" || (type === "wipe" && rotation !== 0)) {
            let newx = document.getElementById(elementId).getBoundingClientRect().x - document.getElementById(mask_rect).getBoundingClientRect().x;
            let newy = document.getElementById(elementId).getBoundingClientRect().y - document.getElementById(mask_rect).getBoundingClientRect().y;
            myRect.setAttribute("x", newx * scaleX);
            myRect.setAttribute("y", newy * scaleY);
            }

        }
        }
    }

    addMaskDOM(domName, idVal, xVal, yVal, widthVal, heightVal, strokeWidthVal)
    {
        var newDOM = document.createElementNS('http://www.w3.org/2000/svg', domName);
        newDOM.setAttributeNS(null, "id", idVal);
        newDOM.setAttributeNS(null, "x", xVal);
        newDOM.setAttributeNS(null, "y", yVal);
        newDOM.setAttributeNS(null, "width", widthVal);
        newDOM.setAttributeNS(null, "height", heightVal);
        newDOM.setAttributeNS(null, "stroke-width", strokeWidthVal);
        newDOM.setAttributeNS(null, "fill", "beige");
        newDOM.setAttributeNS(null, "stroke", "beige");
        return newDOM;
    }

    redrawClipPath(innerblock, mask_rect)
    {
        innerblock.style.clipPath = "none";
        innerblock.style.clipPath = "url(" + mask_rect + ")";
        innerblock.style.webkitClipPath = "url(" + mask_rect + ")"; innerblock.style.mozClipPath = "url(" + mask_rect + ")"; innerblock.style.msClipPath = "url(" + mask_rect + ")"; innerblock.style.oClipPath = "url(" + mask_rect + ")";
    }

    sceneSplitHandler(innerblock, startTime, enterstart, transEffect)
    {
        function onStartTween(blockId)
        {
            var maskFound = this.maskExist(blockId, "split"), type = "split";
            if (!maskFound)
            {
                this.removeMask(blockId);
                if (transEffect === "SlideSplitHorizontalOut" || transEffect === "SlideSplitHorizontalIn" || transEffect === "SlideSplitMoveHor")
                this.addMask(blockId, "splitHor");
                else if (transEffect === "SlideSplitVerticalOut" || transEffect === "SlideSplitVerticalIn" || transEffect === "SlideSplitMoveVer")
                this.addMask(blockId, "splitVer");
            }

            var mask_rect = "#mask_" + blockId + "_rect";
            var totalCount = 2;
            var firstSplit, SecondSplit;

            TweenMax.set(mask_rect, { scale: 1, transformOrigin: "50% 50%" });
            TweenMax.set(innerblock, { scale: 1, transformOrigin: "50% 50%" });

            if (this.browserName !== "Apple Safari")
            {
                if (transEffect === "SlideSplitVerticalOut" || transEffect === "SlideSplitMoveHor")
                {
                firstSplit = { x: this.width * this.zoomFactor * (-1) };
                SecondSplit = { x: this.width * this.zoomFactor };
                }
                else if (transEffect === "SlideSplitMoveVer" || transEffect === "SlideSplitHorizontalOut")
                {
                firstSplit = { y: this.height * this.zoomFactor * (-1) };
                SecondSplit = { y: this.height * this.zoomFactor };
                }
                else if (transEffect === "SlideSplitHorizontalIn")
                {
                firstSplit = { transformOrigin: "50% 100%", scaleY: 0 };
                SecondSplit = { transformOrigin: "50% 0%", scaleY: 0 }
                }

                else if (transEffect === "SlideSplitVerticalIn")
                {
                firstSplit = { transformOrigin: "100% 50%", scaleX: 0 };
                SecondSplit = { transformOrigin: "0% 50%", scaleX: 0 }
                }
            }
            else
            {
                if (transEffect === "SlideSplitVerticalOut" || transEffect === "SlideSplitMoveHor")
                {
                firstSplit = { x: this.width * this.zoomFactor* (-1), onUpdate: this.redrawClipPath, onUpdateParams: [innerblock, "#mymask_" + blockId + type] };
                SecondSplit = { x: this.width * this.zoomFactor, onUpdate: this.redrawClipPath, onUpdateParams: [innerblock, "#mymask_" + blockId + type] };
                }
                else if (transEffect === "SlideSplitMoveVer" || transEffect === "SlideSplitHorizontalOut")
                {
                firstSplit = { y: this.height * this.zoomFactor *  (-1), onUpdate: this.redrawClipPath, onUpdateParams: [innerblock, "#mymask_" + blockId + type] };
                SecondSplit = { y: this.height * this.zoomFactor , onUpdate: this.redrawClipPath, onUpdateParams: [innerblock, "#mymask_" + blockId + type] };
                }
                else if (transEffect === "SlideSplitHorizontalIn")
                {
                firstSplit = { transformOrigin: "50% 100%", scaleY: 0, onUpdate: this.redrawClipPath, onUpdateParams: [innerblock, "#mymask_" + blockId + type] };
                SecondSplit = { transformOrigin: "50% 0%", scaleY: 0, onUpdate: this.redrawClipPath, onUpdateParams: [innerblock, "#mymask_" + blockId + type] }
                }

                else if (transEffect === "SlideSplitVerticalIn")
                {
                firstSplit = { transformOrigin: "100% 50%", scaleX: 0, onUpdate: this.redrawClipPath, onUpdateParams: [innerblock, "#mymask_" + blockId + type] };
                SecondSplit = { transformOrigin: "0% 50%", scaleX: 0, onUpdate: this.redrawClipPath, onUpdateParams: [innerblock, "#mymask_" + blockId + type] }
                }
            }

            for (var count = 0; count < totalCount; count++)
            {
                if (count === 0)
                    this.tween.add(TweenMax.to(mask_rect + count, startTime, firstSplit), enterstart);
                else
                    this.tween.add(TweenMax.to(mask_rect + count, startTime, SecondSplit), enterstart);
            }
        }
        this.tween.add(TweenMax.from(innerblock.id, 0.1, { onStart: onStartTween.bind(this), onStartParams: [innerblock.id], opacity: 1 }), enterstart);
    }

    stripeExitHandler(innerblock, xval, yval, startTime, enterstart, effectType, scaleX, scaleY, opacity, isChild)
    {
        if (scaleY === -1 || scaleX === -1)
        {
            if (effectType === "stripeTopLeft" && scaleY === -1 && scaleX === 1) effectType = "stripe_Bottomleft";
            else if (effectType === "stripeTopLeft" && scaleX === -1 && scaleY === 1) effectType = "stripe_Topright";
            else if (effectType === "stripeTopLeft" && scaleX === -1 && scaleY === -1) effectType = "stripe_Bottomright";
            else if (effectType === "stripe_Topright" && scaleY === -1 && scaleX === 1) effectType = "stripe_Bottomright";
            else if (effectType === "stripe_Topright" && scaleX === -1 && scaleY === 1) effectType = "stripeTopLeft";
            else if (effectType === "stripe_Topright" && scaleX === -1 && scaleY === -1) effectType = "stripe_Bottomleft";
            else if (effectType === "stripe_Bottomleft" && scaleY === -1 && scaleX === 1) effectType = "stripeTopLeft";
            else if (effectType === "stripe_Bottomleft" && scaleX === -1 && scaleY === 1) effectType = "stripe_Bottomright";
            else if (effectType === "stripe_Bottomleft" && scaleX === -1 && scaleY === -1) effectType = "stripe_Topright";
            else if (effectType === "stripe_Bottomright" && scaleY === -1 && scaleX === 1) effectType = "stripe_Topright";
            else if (effectType === "stripe_Bottomright" && scaleX === -1 && scaleY === 1) effectType = "stripe_Bottomleft";
            else if (effectType === "stripe_Bottomright" && scaleX === -1 && scaleY === -1) effectType = "stripeTopLeft";
            else if (effectType === "stripeLeftTop" && scaleY === -1 && scaleX === 1) effectType = "stripeLeftBottom";
            else if (effectType === "stripeLeftTop" && scaleX === -1 && scaleY === 1) effectType = "stripeRightTop";
            else if (effectType === "stripeLeftTop" && scaleX === -1 && scaleY === -1) effectType = "stripeRightBottom";
            else if (effectType === "stripeRightTop" && scaleY === -1 && scaleX === 1) effectType = "stripeRightBottom";
            else if (effectType === "stripeRightTop" && scaleX === -1 && scaleY === 1) effectType = "stripeLeftTop";
            else if (effectType === "stripeRightTop" && scaleX === -1 && scaleY === -1) effectType = "stripeLeftBottom";
            else if (effectType === "stripeLeftBottom" && scaleY === -1 && scaleX === 1) effectType = "stripeLeftTop";
            else if (effectType === "stripeLeftBottom" && scaleX === -1 && scaleY === 1) effectType = "stripeRightBottom";
            else if (effectType === "stripeLeftBottom" && scaleX === -1 && scaleY === -1) effectType = "stripeRightTop";
            else if (effectType === "stripeRightBottom" && scaleY === -1 && scaleX === 1) effectType = "stripeRightTop";
            else if (effectType === "stripeRightBottom" && scaleX === -1 && scaleY === 1) effectType = "stripeLeftBottom";
            else if (effectType === "stripeRightBottom" && scaleX === -1 && scaleY === -1) effectType = "stripeLeftTop";
        }
        
        function onStartTween(blockId, type, effectType)
        {
            if (!type)
                type = "";
            var maskFound = this.maskExist(blockId, type);
            if (!maskFound)
            {
                this.removeMask(blockId);
                this.addMask(blockId, type);
            }
            var mask_rect = "#mask_" + blockId + "_rect";
            var totalCount = 10;
            var num = 0, count = 0;
            TweenMax.set(mask_rect, { opacity: 1, transformOrigin: "50% 50%" });
            TweenMax.set(innerblock, { opacity: opacity, transformOrigin: "50% 50%" });

            if (effectType === "stripe_Topright" || effectType === "stripeTopLeft" || effectType === "stripeLeftTop" || effectType === "stripeLeftBottom" ||
                effectType === "stripeRightBottom" || effectType === "SlideStripeRight" || effectType === "SlideStripeLeft" || effectType === "SlideStripeBottom" || effectType === "SlideStripeTop")
            {
                for (count = 0; count < totalCount; count++)
                {
                    let vars;
                    if (effectType === "stripeTopLeft")
                        vars = { scaleX: 0 };
                    else if (effectType === "stripe_Topright")
                        vars = { transformOrigin: "100%", scaleX: 0 };
                    else if (effectType === "stripeLeftBottom")
                        vars = { scaleY: 0 };
                    else if (effectType === "stripeLeftTop")
                        vars = { transformOrigin: "bottom", scaleY: 0 };
                    else if (effectType === "stripeRightBottom")
                        vars = { transformOrigin: "bottom", scaleY: 0 };
                    else if (this.browserName !== "Apple Safari")
                    {
                        if (effectType === "SlideStripeRight")
                            vars = { scaleX: 0 };
                        else if (effectType === "SlideStripeLeft")
                            vars = { transformOrigin: "100%", scaleX: 0 };
                        else if (effectType === "SlideStripeBottom")
                            vars = { scaleY: 0 };
                        else if (effectType === "SlideStripeTop")
                            vars = { transformOrigin: "bottom", scaleY: 0 };
                    }
                    else
                    {
                        if (effectType === "SlideStripeRight")
                            vars = { transformOrigin: "100%", scaleX: 0 };
                        else if (effectType === "SlideStripeLeft")
                            vars = { transformOrigin: "100%", scaleX: 0, onUpdate: this.redrawClipPath, onUpdateParams: [innerblock, "#mymask_" + blockId + type] };
                        else if (effectType === "SlideStripeBottom")
                            vars = { scaleY: 0, onUpdate: this.redrawClipPath, onUpdateParams: [innerblock, "#mymask_" + blockId + type] };
                        else if (effectType === "SlideStripeTop")
                            vars = { transformOrigin: "bottom", scaleY: 0, onUpdate: this.redrawClipPath, onUpdateParams: [innerblock, "#mymask_" + blockId + type] };
                    }
                    if(vars !== undefined)
                        this.tween.add(TweenMax.to(mask_rect + count, startTime / totalCount, vars), enterstart + ((count * startTime) / totalCount));
                    num++;
                }
            }
            else if (effectType === "stripe_Bottomleft" || effectType === "stripe_Bottomright" || effectType === "stripeRightTop")
            {
                for (count = totalCount; count >= 0; count--)
                {
                    let vars;
                    if (effectType === "stripe_Bottomright")
                        vars = { scaleX: 0 };
                    else if (effectType === "stripe_Bottomleft")
                        vars = { transformOrigin: "100%", scaleX: 0 };
                    else if (effectType === "stripeRightTop")
                        vars = { scaleY: 0 };
                    if(vars !== undefined)
                        this.tween.add(TweenMax.to(mask_rect + count, startTime / totalCount, vars), enterstart + ((num * startTime) / totalCount));
                    num++;
                }
            }
        }

        if (effectType === "stripe_Topright" || effectType === "SlideStripeRight" || effectType === "stripeTopLeft" || effectType === "SlideStripeLeft" || effectType === "stripe_Bottomleft" || effectType === "stripe_Bottomright")
            this.tween.add(TweenMax.from(innerblock.id, 0.1, { onStart: onStartTween.bind(this), onStartParams: [innerblock.id, "multiHeight", effectType], opacity: 1 }), enterstart);
        else if (effectType === "stripeLeftBottom" || effectType === "SlideStripeBottom" || effectType === "stripeRightTop" || effectType === "stripeLeftTop" || effectType === "SlideStripeTop" || effectType === "stripeRightBottom")
            this.tween.add(TweenMax.from(innerblock.id, 0.1, { onStart: onStartTween.bind(this), onStartParams: [innerblock.id, "multiWidth", effectType], opacity: 1 }), enterstart);
    }

    irishExitHandler(innerblock, startTime, exitstart, effectType, isChild)
    {
        function onStartTween(blockId, type)
        {
            if (!type)
                type = "";
            var maskFound = this.maskExist(blockId, type);
            if (!maskFound)
            {
                this.removeMask(blockId);
                this.addMask(blockId, type);
            }

            var mask_rect = "#mask_" + blockId + "_rect";
            TweenMax.set(mask_rect, { scale: 1, transformOrigin: "50% 50%" });
            TweenMax.set(innerblock, { scale: 1, transformOrigin: "50% 50%" });
            if ((effectType !== "SlideIrisSquare" && effectType !== "SlideIrisCircle") || (this.browserName !== "Apple Safari"))
                this.tween.add(TweenMax.to(mask_rect, startTime, { scale: 0, transformOrigin: "50% 50%" }), exitstart);
            else if (this.browserName === "Apple Safari" && (effectType === "SlideIrisSquare" || effectType === "SlideIrisCircle"))
                this.tween.add(TweenMax.to(mask_rect, startTime, { scale: 0, transformOrigin: "50% 50%", onUpdate: this.redrawClipPath, onUpdateParams: [innerblock, "#mymask_" + blockId + type] }), exitstart);
        }

        if (effectType === "irishSquare" || effectType === "SlideIrisSquare")
            this.tween.add(TweenMax.from(innerblock.id, 0.1, { onStart: onStartTween.bind(this), onStartParams: [innerblock.id, "irish"], opacity: 1 }), exitstart);
        else if (effectType === "irishCircle" || effectType === "SlideIrisCircle")
            this.tween.add(TweenMax.from(innerblock.id, 0.1, { onStart: onStartTween.bind(this), onStartParams: [innerblock.id, "circle"], opacity: 1 }), exitstart);
    }

    blindsExitHandler(innerblock, xval, yval, endTime, exitstart, effectType, scaleX, scaleY, opacity, isChild)
    {
        if (scaleY === -1 || scaleX === -1)
        {
            if (effectType === "blindsTop" && scaleY === -1)
                effectType = "blindsBottom";
            else if (effectType === "blindsBottom" && scaleY === -1)
                effectType = "blindsTop";
            else if (effectType === "blindsRight" && scaleX === -1)
                effectType = "blindsLeft";
            else if (effectType === "blindsLeft" && scaleX === -1)
                effectType = "blindsRight";
        }
        function onStartTween(blockId, type)
        {
            if (!type)
                type = "";
            var maskFound = this.maskExist(blockId, type);
            if (!maskFound)
            {
                this.removeMask(blockId);
                this.addMask(blockId, type);
            }
            var mask_rect = "#mask_" + blockId + "_rect";
            TweenMax.set(mask_rect, { opacity: 1, transformOrigin: "50% 50%" });
            TweenMax.set(innerblock, { opacity: opacity, transformOrigin: "50% 50%" });

            var totalCount = 10;
            for (var count = 0; count < totalCount; count++)
            {
                let vars;
                if (effectType === "blindsLeft")
                    vars = { scaleX: 0 };
                else if (effectType === "blindsRight")
                    vars = { transformOrigin: "100%", scaleX: 0 };
                else if (effectType === "blindsTop")
                    vars = { scaleY: 0 };
                else if (effectType === "blindsBottom")
                    vars = { transformOrigin: "bottom", scaleY: 0 };
                else if (this.browserName !== "Apple Safari")
                {
                    if (effectType === "SlideBlindsVerLeft")
                        vars = { scaleX: 0 };
                    else if (effectType === "SlideBlindsVerRight")
                        vars = { transformOrigin: "100%", scaleX: 0 };
                    else if (effectType === "SlideBlindsHorUp")
                        vars = { scaleY: 0 };
                    else if (effectType === "SlideBlindsHorDown")
                        vars = { transformOrigin: "bottom", scaleY: 0 };
                }
                else
                {
                    if (effectType === "SlideBlindsVerLeft")
                        vars = { scaleX: 0, onUpdate: this.redrawClipPath, onUpdateParams: [innerblock, "#mymask_" + blockId + type] };
                    else if (effectType === "SlideBlindsVerRight")
                        vars = { transformOrigin: "100%", scaleX: 0, onUpdate: this.redrawClipPath, onUpdateParams: [innerblock, "#mymask_" + blockId + type] };
                    else if (effectType === "SlideBlindsHorUp")
                        vars = { scaleY: 0, onUpdate: this.redrawClipPath, onUpdateParams: [innerblock, "#mymask_" + blockId + type] };
                    else if (effectType === "SlideBlindsHorDown")
                        vars = { transformOrigin: "bottom", scaleY: 0, onUpdate: this.redrawClipPath, onUpdateParams: [innerblock, "#mymask_" + blockId + type] };
                }
                if(vars !== undefined)
                    this.tween.add(TweenMax.to(mask_rect + count, endTime, vars), exitstart);
            }
        }
        if (effectType === "blindsLeft" || effectType === "SlideBlindsVerLeft" || effectType === "blindsRight" || effectType === "SlideBlindsVerRight")
            this.tween.add(TweenMax.from(innerblock.id, 0.1, { onStart: onStartTween.bind(this), onStartParams: [innerblock.id, "multiWidth"], opacity: 1 }), exitstart);
        else if (effectType === "blindsTop" || effectType === "SlideBlindsHorUp" || effectType === "blindsBottom" || effectType === "SlideBlindsHorDown")
            this.tween.add(TweenMax.from(innerblock.id, 0.1, { onStart: onStartTween.bind(this), onStartParams: [innerblock.id, "multiHeight"], opacity: 1 }), exitstart);
        
    }

    wipeExitHandler(innerblock, startTime, exitstart, effectType, rotation, scaleX, scaleY, opacity, isChild)
    {
        function onStartTween(blockId, type, rotation)
        {
            var maskFound = this.maskExist(blockId, "");
            if (!maskFound)
            {
                this.removeMask(blockId);
                this.addMask(blockId, "wipe", "", rotation, scaleX, scaleY, "", !innerblock.classList.contains("scene-item"));
            }
            var mask_rect = "#mask_" + blockId + "_rect";
            var idVal = document.getElementById(innerblock.id);
            var bboxVal = idVal.getBoundingClientRect();
            var offset = 2;
            var yval = document.getElementById("mask_" + innerblock.id + "_rect").getAttribute("y")
            var xval = document.getElementById("mask_" + innerblock.id + "_rect").getAttribute("x")
            TweenMax.set(mask_rect, { opacity: 1, transformOrigin: "50% 50%" });
            TweenMax.set(innerblock, { opacity: opacity, transformOrigin: "50% 50%" });
            let vars;
            if (type === "wipeTop")
                vars = {attr:{y: parseFloat(yval) + ((bboxVal.height + offset) * scaleY)}};
            else if (type === "wipeDown")
                vars = { attr: { y: parseFloat(yval) + ((bboxVal.height + offset) * -scaleY) } };
            else if (type === "wipeRight")
                vars = { attr: { x: parseFloat(xval) + ((bboxVal.width + offset) * -scaleX) } };
            else if (type === "wipeLeft")
                vars = { attr: { x: parseFloat(xval) + ((bboxVal.width + offset) * scaleX) } };
            else if (this.browserName !== "Apple Safari")
            {
                if (type === "WipeBottom")
                    vars = { attr: { y: parseFloat(yval) + bboxVal.height + offset } };
                else if (type === "WipeTop")
                    vars = { attr: { y: parseFloat(yval) + (bboxVal.height + offset) * -1 } };
                else if (type === "WipeLeft")
                    vars = { attr: { x: parseFloat(xval) + (bboxVal.width + offset) * -1 } };
                else if (type === "WipeRight")
                    vars = { attr: { x: parseFloat(xval) + (bboxVal.width + offset) } };
            }
            else
            {
                if (type === "WipeBottom")
                    vars = { attr: { y: parseFloat(yval) + bboxVal.height + offset }, onUpdate: this.redrawClipPath, onUpdateParams: [innerblock, "#mymask_" + blockId + "wipe"] };
                else if (type === "WipeTop")
                    vars = { attr: { y: parseFloat(yval) + (bboxVal.height + offset) * -1 }, onUpdate: this.redrawClipPath, onUpdateParams: [innerblock, "#mymask_" + blockId + "wipe"] };
                else if (type === "WipeLeft")
                    vars = { attr: { x: parseFloat(xval) + (bboxVal.width + offset) * -1 }, onUpdate: this.redrawClipPath, onUpdateParams: [innerblock, "#mymask_" + blockId + "wipe"] };
                else if (type === "WipeRight")
                    vars = { attr: { x: parseFloat(xval) + (bboxVal.width + offset) }, onUpdate: this.redrawClipPath, onUpdateParams: [innerblock, "#mymask_" + blockId + "wipe"] };
            }
            if(vars !== undefined)
                this.tween.add(TweenMax.to(mask_rect, startTime, vars), exitstart);
        }
        this.tween.add(TweenMax.from(innerblock.id, 0.1, { onStart: onStartTween.bind(this), onStartParams: [innerblock.id, effectType, rotation, opacity], opacity: opacity }), exitstart);
    }

    circularRevealExitHandler(innerblock, startTime, effectType, time, scaleX, scaleY, opacity, isChild)
    {
        var effectVars = {}
        var clipPath = document.querySelector("#arcPath" + innerblock.id);

        var offsetWidthVal = document.getElementById(innerblock.id).offsetWidth;
        var offsetHeightVal = document.getElementById(innerblock.id).offsetHeight;

        if (scaleX === -1 || scaleY === -1)
        {
            if (effectType === "circularHideClockwise" && scaleX === -1 && scaleY === 1) effectType = "circularHideAntiClockwise";
            else if (effectType === "circularHideClockwise" && scaleX === 1 && scaleY === -1) effectType = "circularHideAntiClockwiseBottom";
            else if (effectType === "circularHideClockwise" && scaleX === -1 && scaleY === -1) effectType = "circularHideClockwiseBottom";
            else if (effectType === "circularHideAntiClockwise" && scaleX === -1 && scaleY === 1) effectType = "circularHideClockwise";
            else if (effectType === "circularHideAntiClockwise" && scaleX === 1 && scaleY === -1) effectType = "circularHideClockwiseBottom";
            else if (effectType === "circularHideAntiClockwise" && scaleX === -1 && scaleY === -1) effectType = "circularHideAntiClockwiseBottom";
            else if (effectType === "circularHideClockwiseRight" && scaleX === -1 && scaleY === 1) effectType = "circularHideAntiClockwiseLeft";
            else if (effectType === "circularHideClockwiseRight" && scaleX === 1 && scaleY === -1) effectType = "circularHideAntiClockwiseRight";
            else if (effectType === "circularHideClockwiseRight" && scaleX === -1 && scaleY === -1) effectType = "circularHideClockwiseLeft";
            else if (effectType === "circularHideAntiClockwiseRight" && scaleX === -1 && scaleY === 1) effectType = "circularHideClockwiseLeft";
            else if (effectType === "circularHideAntiClockwiseRight" && scaleX === 1 && scaleY === -1) effectType = "circularHideClockwiseRight";
            else if (effectType === "circularHideAntiClockwiseRight" && scaleX === -1 && scaleY === -1) effectType = "circularHideAntiClockwiseLeft";
            else if (effectType === "circularHideClockwiseLeft" && scaleX === -1 && scaleY === 1) effectType = "circularHideAntiClockwiseRight";
            else if (effectType === "circularHideClockwiseLeft" && scaleX === 1 && scaleY === -1) effectType = "circularHideAntiClockwiseLeft";
            else if (effectType === "circularHideClockwiseLeft" && scaleX === -1 && scaleY === -1) effectType = "circularHideClockwiseRight";
            else if (effectType === "circularHideAntiClockwiseLeft" && scaleX === -1 && scaleY === 1) effectType = "circularHideClockwiseRight";
            else if (effectType === "circularHideAntiClockwiseLeft" && scaleX === 1 && scaleY === -1) effectType = "circularHideClockwiseLeft";
            else if (effectType === "circularHideAntiClockwiseLeft" && scaleX === -1 && scaleY === -1) effectType = "circularHideAntiClockwiseRight";
            else if (effectType === "circularHideClockwiseBottom" && scaleX === -1 && scaleY === 1) effectType = "circularHideAntiClockwiseBottom";
            else if (effectType === "circularHideClockwiseBottom" && scaleX === 1 && scaleY === -1) effectType = "circularHideAntiClockwise";
            else if (effectType === "circularHideClockwiseBottom" && scaleX === -1 && scaleY === -1) effectType = "circularHideClockwise";
            else if (effectType === "circularHideAntiClockwiseBottom" && scaleX === -1 && scaleY === 1) effectType = "circularHideClockwiseBottom";
            else if (effectType === "circularHideAntiClockwiseBottom" && scaleX === 1 && scaleY === -1) effectType = "circularHideClockwise";
            else if (effectType === "circularHideAntiClockwiseBottom" && scaleX === -1 && scaleY === -1) effectType = "circularHideAntiClockwise";
        }

        var radiusVal = (offsetWidthVal > offsetHeightVal) ? offsetWidthVal : offsetHeightVal;
        if (effectType === "circularHideAntiClockwise")
            effectVars = { start: 0, endEnter: 360, endExit: 0 }
        else if (effectType === "circularHideClockwise" || effectType === "SlideCircularReveal")
            effectVars = { start: 360, endEnter: 0, endExit: 360 }
        else if (effectType === "circularHideAntiClockwiseRight")
            effectVars = { start: 90, endEnter: this.projectHeight, endExit: 90 }
        else if (effectType === "circularHideClockwiseRight")
            effectVars = { start: 90, endEnter: -270, endExit: 90 }
        else if (effectType === "circularHideAntiClockwiseLeft")
            effectVars = { start: 270, endEnter: 630, endExit: 270 }
        else if (effectType === "circularHideClockwiseLeft")
            effectVars = { start: 270, endEnter: -90, endExit: 270 }
        else if (effectType === "circularHideAntiClockwiseBottom")
            effectVars = { start: 180, endEnter: 540, endExit: 180 }
        else if (effectType === "circularHideClockwiseBottom")
            effectVars = { start: 180, endEnter: -180, endExit: 180 }

        var arc = { start: effectVars.start, end: effectVars.endEnter, cx: offsetWidthVal / 2, cy: offsetHeightVal / 2, r: radiusVal };
        function onStartTween(blockId, type)
        {
            this.removeMask(innerblock.id);
            this.addMask(innerblock.id, "circularReveal");
            clipPath = document.querySelector("#arcPath" + innerblock.id);

            TweenMax.set("arcPath" + innerblock.id, { opacity: 1, transformOrigin: "50% 50%" });
            TweenMax.set(innerblock, { opacity: opacity, transformOrigin: "50% 50%" });
        }

        if (effectType === "circularHideAntiClockwise" || effectType === "circularHideAntiClockwiseRight" || effectType === "circularHideAntiClockwiseLeft" ||
        effectType === "circularHideAntiClockwiseBottom")
        {
            this.tween.add(TweenMax.to(arc, startTime, { onStart: onStartTween.bind(this), onStartParams: [innerblock.id, ""], end: effectVars.endExit, ease: Linear.easeNone, onUpdate: updatePath }), time);
            function updatePath()
            {
                if (clipPath !== null)
                clipPath.setAttribute("d", getPath(arc.cx, arc.cy, arc.r, arc.start, arc.end));
            }
        }

        else if (effectType === "circularHideClockwise" || effectType === "SlideCircularReveal" || effectType === "circularHideClockwiseRight" || effectType === "circularHideClockwiseLeft" ||
        effectType === "circularHideClockwiseBottom")
        {
           
            this.tween.add(TweenMax.to(arc, startTime, { onStart: onStartTween.bind(this), onStartParams: [innerblock.id, ""], end: effectVars.endExit, ease: Linear.easeNone, onUpdate: updatePath.bind(this) }), time);
            function updatePath()
            {
                if (effectType === "SlideCircularReveal" && this.browserName === "Apple Safari")
                this.redrawClipPath(innerblock, "#mymask_" + innerblock.id + "circularReveal");
                if (clipPath !== null)
                clipPath.setAttribute("d", getPath(arc.cx, arc.cy, arc.r, arc.end, arc.start));
            }
        }

        function getPath(cx, cy, r, a1, a2)
        {
            var delta = a2 - a1;
            if (delta === 360)
            {
                return "M " + (cx - r) + " " + cy + " a " + r + " " + r + " 0 1 0 " + r * 2 + " 0 a " + r + " " + r + " 0 1 0 " + -r * 2 + " 0z";
            }
            var largeArc = delta > 180 ? 1 : 0;
            a1 = a1 * Math.PI / 180 - Math.PI / 2;
            a2 = a2 * Math.PI / 180 - Math.PI / 2;
            var x1 = cx + r * Math.cos(a2);
            var y1 = cy + r * Math.sin(a2);
            var x2 = cx + r * Math.cos(a1);
            var y2 = cy + r * Math.sin(a1);
            return "M " + x1 + " " + y1 + " A " + r + " " + r + " 0 " + largeArc + " 0 " + x2 + " " + y2 + " L " + cx + " " + cy + "z";
        }
    }

    brightSquareSlideEnterHandler(innerblock, startTime, enterstart)
    {
        function onStartTween(blockId)
        {
            var maskFound = this.maskExist(blockId, "slidesquare");
            if (!maskFound) 
            {
                this.removeMask(blockId);
                this.addMask(blockId, "slidesquare");
            }

            var mask_rect = "#mask_" + innerblock.id + "_rect";
        
            TweenMax.set(mask_rect, { scale: 1, transformOrigin: "50% 50%" });
            TweenMax.set(innerblock, { scale: 1, transformOrigin: "50% 50%" });

            var totalCount = 6;
            for (var count = 0; count < totalCount; count++)
            {
                for (var cnt = 0; cnt < totalCount; cnt++)
                {
                if (this.browserName !== "Apple Safari")
                    this.tween.add(TweenMax.to(mask_rect + count + cnt, startTime, { transformOrigin: "50% 50%", scale: 0 }), enterstart);
                else
                    this.tween.add(TweenMax.to(mask_rect + count + cnt, startTime, { transformOrigin: "50% 50%", scale: 0, onUpdate: this.redrawClipPath, onUpdateParams: [innerblock, "#mymask_" + innerblock.id + "square"] }), enterstart);
                }
            }
        }
        this.tween.add(TweenMax.from(innerblock.id, 0.1, { onStart: onStartTween.bind(this), onStartParams: [innerblock.id], opacity: 1 }), enterstart);
    }

    previewScene(effectName){
       
        let workspaceBounds = document.getElementById("workspace").getElementsByClassName("scenes")[0].getBoundingClientRect();
        this.killTween;
        this.tween = new TimelineMax({paused : true, opacity : 1});
        document.getElementById("workspace").getElementsByClassName("scenes")[0].style.overflow = "hidden";
        if(effectName === "SlideLeft"){
            this.tween.add(TweenMax.to(document.getElementById("workspace").getElementsByClassName("scenes")[0], 1, { x: workspaceBounds.width * -1 }), 0);
        }
        else if(effectName === "SlideRight"){
            this.tween.add(TweenMax.to(document.getElementById("workspace").getElementsByClassName("scenes")[0], 1, { x: workspaceBounds.width }), 0);
        }
        else if(effectName === "SlideTop"){
            this.tween.add(TweenMax.to(document.getElementById("workspace").getElementsByClassName("scenes")[0], 1, { y: workspaceBounds.height * -1 }), 0);
        }
        else if(effectName === "SlideBottom"){
            this.tween.add(TweenMax.to(document.getElementById("workspace").getElementsByClassName("scenes")[0], 1, { y: workspaceBounds.height }), 0);
        }
        else if (effectName === "SlideSplitVerticalOut" || effectName === "SlideSplitHorizontalOut" || effectName === "SlideSplitVerticalIn" || effectName === "SlideSplitHorizontalIn" || effectName === "SlideSplitMoveVer" || effectName === "SlideSplitMoveHor")
        {
          this.sceneSplitHandler(document.getElementById("workspace").getElementsByClassName("scenes")[0], 0.8, 0, effectName);
        }
        else if (effectName === "SlideStripeLeft" || effectName === "SlideStripeRight" || effectName === "SlideStripeBottom" || effectName === "SlideStripeTop")
        {
          this.stripeExitHandler(document.getElementById("workspace").getElementsByClassName("scenes")[0], 0, 0, 0.8, 0, effectName, 1, 1)
        }
        else if (effectName === "SlideIrisCircle" || effectName === "SlideIrisSquare")
        {
          this.irishExitHandler(document.getElementById("workspace").getElementsByClassName("scenes")[0], 1, 0, effectName);
        }
        else if (effectName === "SlideBlindsVerLeft" || effectName === "SlideBlindsVerRight" || effectName === "SlideBlindsHorDown" || effectName === "SlideBlindsHorUp")
        {
          this.blindsExitHandler(document.getElementById("workspace").getElementsByClassName("scenes")[0], 0, 0, 0.8, 0, effectName, 1, 1)
        }
        else if (effectName === "WipeLeft" || effectName === "WipeTop" || effectName === "WipeRight" || effectName === "WipeBottom")
        {
          this.wipeExitHandler(document.getElementById("workspace").getElementsByClassName("scenes")[0], 0.8, 0, effectName, 0, 1, 1);
        }
        else if (effectName === "SlideCircularReveal")
        {
          this.circularRevealExitHandler(document.getElementById("workspace").getElementsByClassName("scenes")[0], 0.8, effectName, 0, 1, 1);
        }
        else if (effectName === "SlideFade")
        {
            this.tween.add(TweenMax.fromTo(document.getElementById("workspace").getElementsByClassName("scenes")[0], 0, { opacity: 1 }, { opacity: 0 }), 0.5);
            this.tween.add(TweenMax.fromTo(document.getElementById("workspace").getElementsByClassName("scenes")[0], 0.5, { opacity: 0 }, { opacity: 1 }), 1);
        }
        else if (effectName === "SlideBrightSquare")
        {
          this.brightSquareSlideEnterHandler(document.getElementById("workspace").getElementsByClassName("scenes")[0], 0.8, 0)
        }
        
        this.tween.eventCallback("onComplete", function(ev, e){
            ev.removeMask(document.getElementById("workspace").getElementsByClassName("scenes")[0].id);
            document.getElementById("workspace").getElementsByClassName("scenes")[0].style.transform = "none";
            document.getElementById("workspace").getElementsByClassName("scenes")[0].style.clipPath = "unset";
            document.getElementById("workspace").getElementsByClassName("scenes")[0].style.transformOrigin = "initial";
            document.getElementById("workspace").getElementsByClassName("scenes")[0].style.overflow = "unset";
            e.pause(0);
            ev.killTween;
            
        }, [this, "{self}"]).play();
        
        return false;
    }

    killTween(){
        this.tween.kill();
        this.tween.eventCallback("onComplete", null);
        this.tween.eventCallback("onUpdate", null);
        this.tween.eventCallback("onStart", null);
        this.tween.clear();
    }

}

export function spontaneousFilters(selectedItems, selectedScene, svgFilterItem, presetName, changingValues, inputValue, type) {
    
    let brightness = 0
    let contrast = 0
    let hue = 0
    let saturate
    let tint
    let blur
    let vignette = 0
    
    if(type === "intensity"){
        let FilterValues = changingValues[presetName]
        // console.log({...FilterValues});
        
        brightness  = (FilterValues.bright * (inputValue/100) > 100 )   ? 100: (FilterValues.bright * (inputValue/100) < -100 )? -100 : FilterValues.bright * (inputValue/100)
        contrast    = (FilterValues.contrast * (inputValue/100) > 100 ) ? 100: (FilterValues.contrast * (inputValue/100) < -100 )? -100 : FilterValues.contrast * (inputValue/100)
        hue         = (FilterValues.hue * (inputValue/100) > 100 )      ? 100: (FilterValues.hue * (inputValue/100) < -100 )? -100 : FilterValues.hue * (inputValue/100)
        saturate    = (FilterValues.saturate * (inputValue/100) > 100 ) ? 100: (FilterValues.saturate * (inputValue/100) < -100 )? -100 : FilterValues.saturate * (inputValue/100)
        tint        = (inputValue === 0) ? 0 : FilterValues.tint
        blur        = (FilterValues.blur * (inputValue/100) > 100 )     ? 100: (FilterValues.blur * (inputValue/100) < -100 )? -100 : FilterValues.blur * (inputValue/100)
        vignette    = (FilterValues.vignette * (inputValue/100) > 100 ) ? 100: (FilterValues.vignette * (inputValue/100) < -100 )? -100 : FilterValues.vignette * (inputValue/100)
        
    }
    else if(type === "bright"){
        brightness = inputValue
    }
    else if(type === "contrast"){
        contrast = inputValue
    }
    else if(type === "hue"){
        hue = inputValue
    }
    else if(type === "saturate"){
        saturate = inputValue
    }
    else if(type === "tint"){
        tint = inputValue
    }
    else if(type === "blur"){
        blur = inputValue
    }
    else if(type === "vignette"){
        vignette = inputValue
    }
        
    if (brightness !== 0) {
        svgFilterItem.getElementById("RbrightnessSVG").setAttribute("intercept", brightness/200)
        svgFilterItem.getElementById("GbrightnessSVG").setAttribute("intercept", brightness/200)
        svgFilterItem.getElementById("BbrightnessSVG").setAttribute("intercept", brightness/200)
    }

    if(contrast !== 0){

        svgFilterItem.getElementById("RcontrastSVG").setAttribute("slope", (contrast < 0)? ((contrast + 100) * 0.006)+0.4: ((contrast * 1.5)/100)+ 1)
        svgFilterItem.getElementById("GcontrastSVG").setAttribute("slope", (contrast < 0)? ((contrast + 100) * 0.006)+0.4: ((contrast * 1.5)/100)+ 1)
        svgFilterItem.getElementById("BcontrastSVG").setAttribute("slope", (contrast < 0)? ((contrast + 100) * 0.006)+0.4: ((contrast * 1.5)/100)+ 1)

        svgFilterItem.getElementById("RcontrastSVG").setAttribute("intercept", (contrast > 0)? (-((contrast * 75/100)/100)): (-(contrast * 30/100)/100))
        svgFilterItem.getElementById("GcontrastSVG").setAttribute("intercept", (contrast > 0)? (-((contrast * 75/100)/100)): (-(contrast * 30/100)/100))
        svgFilterItem.getElementById("BcontrastSVG").setAttribute("intercept", (contrast > 0)? (-((contrast * 75/100)/100)): (-(contrast * 30/100)/100))

    }

    if (hue !== 0) {
        svgFilterItem.getElementById("HueSVG").setAttribute("values", hue)
    }

    if(saturate !== 0 && saturate !== undefined) {
        // svgFilterItem.getElementById("saturateSVG").setAttribute("values", ( saturate + 100 ) * 2 / 100)
        // console.log(saturate);
        
        let filterValue = [
            ((saturate + 100) * (1.6914 - 0.3086 ) /(200)) + 0.3086, 
            ((saturate + 100) * (- 0.6094 - 0.6094  ) /(200)) + 0.6094, 
            ((saturate + 100) * (- 0.082 - 0.082 ) /(200)) + 0.082, 
            0,
            0,
            ((saturate + 100) * (- 0.3086 - 0.3086 )/(200)) + 0.3086, 
            ((saturate + 100) * (1.3906 - 0.6094 )/(200)) + 0.6094, 
            ((saturate + 100) * (- 0.082 - 0.082 )/(200)) + 0.082, 
            0,
            0,
            ((saturate + 100) * (- 0.3086 - 0.3086 )/(200)) + 0.3086,
            ((saturate + 100) * (- 0.6094 - 0.6094 )/(200)) + 0.6094,
            ((saturate + 100) * (1.918 - 0.082 )/(200)) + 0.082,
            0,
            0,
            0, 0, 0,
            1,
            0
          ].join(',')

        svgFilterItem.getElementById("saturateSVG").setAttribute("values", filterValue)
    }
    else if(saturate === 0){
        // svgFilterItem.getElementById("saturateSVG").setAttribute("values", 2)

        svgFilterItem.getElementById("saturateSVG").removeAttribute("values")
    }

    
    var feFuncR = svgFilterItem.getElementById("RtintSVG")
    var feFuncG = svgFilterItem.getElementById("GtintSVG")
    var feFuncB = svgFilterItem.getElementById("BtintSVG")
    if(tint !== 0 && tint !== undefined) {
        feFuncR.setAttribute("slope", 0.9)
        feFuncG.setAttribute("slope", 0.9)
        feFuncB.setAttribute("slope", 0.9)       

        if(tint >0 && tint <= 33){
            feFuncR.setAttribute("intercept", 0)
            feFuncG.setAttribute("intercept", 0.1)
            feFuncB.setAttribute("intercept", tint/330)
        }
        else if (tint > 33 && tint < 66){
            feFuncR.setAttribute("intercept", 0)
            feFuncG.setAttribute("intercept", (33-tint%33)/330)
            feFuncB.setAttribute("intercept", 0.1)
        }
        else if (tint >= 66){
            feFuncR.setAttribute("intercept", (tint-66)/330)
            feFuncG.setAttribute("intercept", 0)
            feFuncB.setAttribute("intercept", 0.1)
        }
        else if(tint < 0 && tint >= -33){
            feFuncR.setAttribute("intercept", -(tint/330))
            feFuncG.setAttribute("intercept", 0.1)
            feFuncB.setAttribute("intercept", 0)
        }
        else if (tint < -33 && tint > -66){
            feFuncR.setAttribute("intercept", 0.1)
            feFuncG.setAttribute("intercept", (33-(-tint)%33)/330)
            feFuncB.setAttribute("intercept", 0)
        }
        else if (tint <= -66){
            feFuncR.setAttribute("intercept", 0.1)
            feFuncG.setAttribute("intercept", 0)
            feFuncB.setAttribute("intercept", -((tint+66)/330))
        }
    }
    else if(tint === 0) {
        feFuncR.removeAttribute("slope")
        feFuncG.removeAttribute("slope")
        feFuncB.removeAttribute("slope")       

        feFuncR.removeAttribute("intercept")
        feFuncG.removeAttribute("intercept")
        feFuncB.removeAttribute("intercept")       
    }

    if(blur !== 0 && blur !== undefined){

        if(blur>0){

            svgFilterItem.getElementsByTagName("feGaussianBlur")[0].setAttribute('stdDeviation', (blur * 3) / 10)
            svgFilterItem.getElementsByTagName("feComposite")[0].removeAttribute('operator')
            svgFilterItem.getElementsByTagName("feComposite")[0].removeAttribute('k1')
            svgFilterItem.getElementsByTagName("feComposite")[0].removeAttribute('k2')
            svgFilterItem.getElementsByTagName("feComposite")[0].removeAttribute('k3')
            svgFilterItem.getElementsByTagName("feComposite")[0].removeAttribute('k4')
            svgFilterItem.getElementsByTagName("feComposite")[0].removeAttribute('in2')

        }
        else if(blur < 0){

            svgFilterItem.getElementsByTagName("feGaussianBlur")[0].setAttribute('stdDeviation', 1)
            svgFilterItem.getElementsByTagName("feComposite")[0].setAttribute('operator', "arithmetic")
            svgFilterItem.getElementsByTagName("feComposite")[0].setAttribute('k1', 0)
            svgFilterItem.getElementsByTagName("feComposite")[0].setAttribute('k2', (blur * 6/100))
            svgFilterItem.getElementsByTagName("feComposite")[0].setAttribute('k3', (((blur* 6/100) * -1)+1))
            svgFilterItem.getElementsByTagName("feComposite")[0].setAttribute('k4', 0)
            svgFilterItem.getElementsByTagName("feComposite")[0].setAttribute('in2', "preblur")

        }

    }
    else if(blur === 0){
        svgFilterItem.getElementsByTagName("feGaussianBlur")[0].setAttribute('stdDeviation', 0)
        svgFilterItem.getElementsByTagName("feComposite")[0].removeAttribute('operator')
        svgFilterItem.getElementsByTagName("feComposite")[0].removeAttribute('k1')
        svgFilterItem.getElementsByTagName("feComposite")[0].removeAttribute('k2')
        svgFilterItem.getElementsByTagName("feComposite")[0].removeAttribute('k3')
        svgFilterItem.getElementsByTagName("feComposite")[0].removeAttribute('k4')
        svgFilterItem.getElementsByTagName("feComposite")[0].removeAttribute('in2')
    }

    if (vignette !== 0) {
        if(selectedItems.size>0) {
            let vignetteId = selectedItems.get(0) + "-vignette-" + selectedScene
            
            document.getElementById(vignetteId).style.backgroundImage = `radial-gradient(circle farthest-side at center center, rgba(0, 0, 0, 0) 70%, rgba(0, 0, 0, ${vignette * 0.007}) 130%)`
        }
        else if(selectedItems.size === 0) {
            let vignetteId = "ws-vignette-" + selectedScene

            document.getElementById(vignetteId).style.backgroundImage = `radial-gradient(circle farthest-side at center center, rgba(0, 0, 0, 0) 70%, rgba(0, 0, 0, ${vignette * 0.007}) 130%)`
        }
    }
}



// WEBPACK FOOTER //
// ./src/helpers/previewHelper.js